import { Avatar, BalanceText, ListItem, Text, Tooltip, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { CustomerLayoutProps } from '.';

export const Tablet: React.FC<CustomerLayoutProps> = ({
  backgroundColorBadge,
  balance,
  document,
  name,
  registrationStatus,
  suitability,
}) => {
  return (
    <HStack p={Spacing['inline.xxs']} alignItems="center" justifyContent="space-between">
      <HStack alignItems="center" space={Spacing['inline.nano']}>
        <Tooltip label={suitability}>
          <Box justifyContent="center" h={Spacing['inline.sm']}>
            <Avatar
              bgColor={backgroundColorBadge}
              initials={suitability}
              testId="suitability-avatar-tablet"
              textColor="neutral.white"
            />
          </Box>
        </Tooltip>
        <ListItem testId="name" title="Nome">
          <Tooltip testID="tooltip-name" label={name}>
            <VStack>
              <Text>{name}</Text>
            </VStack>
          </Tooltip>
        </ListItem>
      </HStack>
      <ListItem testId="document" title="CPF/CNPJ">
        {document}
      </ListItem>
      <ListItem testId="registration-status" title="Cadastro">
        {registrationStatus}
      </ListItem>
      <VStack alignItems="end">
        <Text variant="semibold" lineHeight="distant" pr={Spacing['inline.nano']}>
          Saldo disponível
        </Text>
        <BalanceText
          balance={balance.available}
          isUpdating={balance.isLoading}
          onUpdateButtonPress={balance.onUpdateButton}
          lastUpdatedAt={balance.lastUpdatedAt}
          hasUpdateButton
          textAlign="flex-end"
          positiveBalanceColor="neutral.black"
          negativeBalanceColor="feedback.error.default"
        />
      </VStack>
      <VStack alignItems="flex-end" w="130px">
        <Text lineHeight="distant" fontSize={Typography['fontsize.md']} variant="semibold">
          Saldo estimado
        </Text>
        <Box alignItems="flex-end">
          <Text
            fontSize={Typography['fontsize.md']}
            numberOfLines={1}
            {...(balance.estimated.startsWith('-') && { color: 'feedback.error.default' })}>
            {balance.estimated}
          </Text>
          <Text color="neutral.light" fontSize={Typography['fontsize.xs']}>
            Após investimento
          </Text>
        </Box>
      </VStack>
    </HStack>
  );
};
